import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
import { Deprecated } from '../Deprecated';
var TextUnderlineIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M20.25 14.7798V23.7798C20.25 25.8698 21.83 27.21 24.04 27.21C26.25 27.21 27.8 25.8698 27.8 23.7798V14.7798H29.9099V23.7798C29.9099 26.9298 27.49 29 23.98 29C20.47 29 18.0898 26.9298 18.0898 23.7898V14.7898L20.25 14.7798ZM29.9099 31.23V33.23H18.0898V31.23H29.9099Z"
  }));
});
TextUnderlineIcon.displayName = 'TextUnderlineIcon';
TextUnderlineIcon.defaultProps = {
  'aria-label': 'Text Underline'
};
/**
 * @deprecated Use UnderlineIcon instead.
 */

export default Deprecated(TextUnderlineIcon, 'Use UnderlineIcon instead.');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/TextUnderlineIcon/index.js
// module id = 1957
// module chunks = 12